import request from './request';

export default {
	async getTickets() {
		const res = await request.get('/app/tickets');
		return res;
	},
	async getLaundryRooms() {
		const res = await request.get('/app/laundry-rooms');
		return res;
	},
	async getLaundryRoomMachines() {
		const res = await request.get('/app/laundry-rooms/machines');
		return res;
	},
	async getPaymentMethods() {
		const res = await request.get('/app/tickets/payment-methods');
		return res;
	},
	async getTicketById(query) {
		const res = await request.get('/app/tickets/id', query);
		return res;
	},
	async updateTicketById(id, body) {
		const res = await request.patch(`/app/tickets/id?id=${id}`, body);
		return res;
	},
	async updateTicketLaundryRoomById(id, body) {
		const res = await request.patch(`/app/tickets/id/laundry-room?id=${id}`, body);
		return res;
	},
	async purchaseTicket(body) {
		const res = await request.post('/app/tickets', body);
		return res;
	},
	async status(id) {
		const res = await request.post(`/app/tickets/id/status?id=${id}`);
		return res;
	}
};
